import { LABEL_REQUIRED } from "../../../common/constants"
import clsx from "clsx"

export default function LabelRequired({ className }) {
  return (
    <span className={clsx("label-required", className)}>{LABEL_REQUIRED}</span>
  )
}
